// This file was auto-generated by Fern from our API Definition.
export var AdminUserIdentityRead;
(function (AdminUserIdentityRead) {
    AdminUserIdentityRead.Status = {
        Created: "created",
        Linked: "linked",
        PendingConfirmation: "pending_confirmation",
        Skipped: "skipped",
        Failed: "failed",
    };
})(AdminUserIdentityRead || (AdminUserIdentityRead = {}));
